import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { getCustomer } from '../../../apis/queries';
import Loader from '../../../components/Loader';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import NotFound from '../../NotFound';
import CustomerDetailForm from './CustomerDetailForm';

const EditCustomerButton = ({
  isEditMode,
  isEditFormSubmitting,
  ...props
}: {
  isEditMode: boolean;
  isEditFormSubmitting: boolean;
  onClick: () => void;
}) => {
  return (
    <Button disabled={isEditFormSubmitting} {...props}>
      {' '}
      {isEditMode ? 'View Mode' : 'Edit Mode'}
    </Button>
  );
};

const CustomerDetail = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <CustomerDetailContent id={id} />;
};

const CustomerDetailContent = ({ id }: { id: string }) => {
  const CUSTOMER_ID_QUERY_KEY = ['customers', { id }];
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditFormSubmitting, setEditFormSubmitting] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: CUSTOMER_ID_QUERY_KEY,
    queryFn: () => getCustomer(id),
    enabled: !!id
  });

  const customer = data?.data;

  if (isLoading) {
    return <Loader fullscreen />;
  }

  const onEditButtonClicked = () => {
    setIsEditMode(!isEditMode);
  };

  const onEditFormSubmit = (loading: boolean) => {
    setEditFormSubmitting(loading);
  };

  if (!customer) {
    return <NotFound />;
  }

  return (
    <div className="main-content">
      <Header
        title={customer?.name}
        isDetailPage
        headerButton={
          <EditCustomerButton
            isEditFormSubmitting={isEditFormSubmitting}
            isEditMode={isEditMode}
            onClick={onEditButtonClicked}
          />
        }
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <CustomerDetailForm
              customer={customer}
              isEditMode={isEditMode}
              isEditFormSubmitting={isEditFormSubmitting}
              onEditFormSubmit={onEditFormSubmit}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CustomerDetail;
